<script lang="ts">
  import { twJoin } from "tailwind-merge";
  import Divider, {
    type SpacingTop,
    type SpacingBottom,
    type Width,
  } from "@elements/Divider.svelte";

  /**
   * Block Props
   */
  export let spacing_top: { value: SpacingTop } = "0";
  export let spacing_bottom: { value: SpacingBottom } = "0";
  export let width: { value: Width } = {
    value: "container",
  };
</script>

<Divider
  top={spacing_top.value}
  bottom={spacing_bottom.value}
  width={width.value}
/>
